/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const BOOK_OPEN_VIEWBOX = 16;

const BOOK_OPEN_PATH =
  'M7.99992 4.66667V14M1.99992 12C1.63198 12 1.33325 11.7013 1.33325 11.3333V2.66667C1.33325 2.29872 1.63198 2 1.99992 2H5.33325C6.80503 2 7.99992 3.19489 7.99992 4.66667C7.99992 3.19489 9.19481 2 10.6666 2H13.9999C14.3679 2 14.6666 2.29872 14.6666 2.66667V11.3333C14.6666 11.7013 14.3679 12 13.9999 12H9.99992C8.89609 12 7.99992 12.8962 7.99992 14C7.99992 12.8962 7.10375 12 5.99992 12L7.99992 4.66667';

const iconPropTypes = {
  size: PropTypes.number,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Open book (16×16). Color via `stroke` / `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const BookOpenIcon = ({
  size = 16,
  stroke = 'currentColor',
  strokeWidth = 1.33333,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${BOOK_OPEN_VIEWBOX} ${BOOK_OPEN_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d={BOOK_OPEN_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BookOpenIcon.propTypes = iconPropTypes;

export { BookOpenIcon };
export default BookOpenIcon;
